import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { ICrisisActions, ICrisisStore, IThunkEditCrisisAddress } from '../types';

const onEditCrisisAddress: IThunkEditCrisisAddress = thunk(
  async ({ setCrisisCalls }: Actions<ICrisisActions>, { clinicId, id, data }, { getState }) => {
    const updatedCrisisCall = await api.crisis
      .editCrisisAddress(clinicId, id, data)
      .then(r => r.data);

    const { crisisCalls } = getState() as ICrisisStore;

    setCrisisCalls(crisisCalls.map(call => (call.crisisCallId === id ? updatedCrisisCall : call)));

    return updatedCrisisCall;
  },
);

export default onEditCrisisAddress;
